import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const SiteSpectContext = createContext();

const SiteSpectProvider = ({ children, value }) =>
  <SiteSpectContext.Provider value={value}>{children}</SiteSpectContext.Provider>;

SiteSpectProvider.defaultProps = {
  value: {}
};

SiteSpectProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object
};

const useSiteSpect = () => {
  const context = useContext(SiteSpectContext);

  if (context === undefined) {
    throw new Error('useSiteSpect must be used within a SiteSpectProvider');
  }

  return context;
};

export { SiteSpectProvider, useSiteSpect };
